module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAERSURBVEiJtdaxagJBEAbgf/Qa22sUH0CIKXNaXxm0SXI+REALexsbCysJxGcwlWJrlTLk0qe1SqVFQCwsnFQRBYX9Z8+/GmZZPliYZQAynaQedZJ6xN7LUcjj3TNUU6im7aeoezUIkusdSsiIwShIFfMTl8DyDNQsVRbbwu4WkOoRdl+7Kf+m3z8fmUHvy+W+UaxMLRgF+WA0ZMVMkAUzQyzmBTGYN+SKSRbQf/pxHKzCzRsgycmBSI37ghwigJ7rB1kB/TgO1uFmopDWcV8Vw/H08yuTp7uEQPHyOku7AOANuSDekCviBTGIGWIRE2RBaMiKAOQcrcLtCAYEYJcT6IMF4SHdDw6lYuiKmGJdIP8AOMrTMr2cLecAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/m6.png
// module id = VoEj
// module chunks = 1